import React, { useState, useEffect, useRef } from 'react';
import { ChevronDown, Plus, Trash2 } from 'lucide-react';

export const AddDropdown = ({ isTableActive, handleFormatAction }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setIsOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="toolbar-dropdown-container" ref={dropdownRef}>
            <button
                className={`toolbar-action-trigger add-trigger ${!isTableActive ? 'disabled' : ''}`}
                onClick={() => isTableActive && setIsOpen(!isOpen)}
                disabled={!isTableActive}
            >
                <Plus size={14} />
                <span>Add</span>
                <ChevronDown size={11} className="chevron-icon" />
            </button>
            {isOpen && (
                <div className="toolbar-dropdown-menu">
                    <button className="toolbar-dropdown-item" onClick={() => { handleFormatAction('addRow'); setIsOpen(false); }}>
                        Add Row
                    </button>
                    <button className="toolbar-dropdown-item" onClick={() => { handleFormatAction('addColumn'); setIsOpen(false); }}>
                        Add Column
                    </button>
                </div>
            )}
        </div>
    );
};

export const DeleteDropdown = ({ isTableActive, handleFormatAction }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setIsOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="toolbar-dropdown-container" ref={dropdownRef}>
            <button
                className={`toolbar-action-trigger delete-trigger ${!isTableActive ? 'disabled' : ''}`}
                onClick={() => isTableActive && setIsOpen(!isOpen)}
                disabled={!isTableActive}
            >
                <Trash2 size={13} />
                <span>Delete</span>
                <ChevronDown size={11} className="chevron-icon" />
            </button>
            {isOpen && (
                <div className="toolbar-dropdown-menu">
                    <button className="toolbar-dropdown-item" onClick={() => { handleFormatAction('deleteRow'); setIsOpen(false); }}>
                        Delete Row
                    </button>
                    <button className="toolbar-dropdown-item" onClick={() => { handleFormatAction('deleteColumn'); setIsOpen(false); }}>
                        Delete Column
                    </button>
                </div>
            )}
        </div>
    );
};
